module.exports = __webpack_public_path__ + "static/media/reports.493c3d6a.png";